import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";
import { Fragment, useState } from "react";
// import { isDefined  } from "../../config/helpers";
import useWindowSize from "../../_hooks/useWindowSize";

import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import useArticle from "@components/_hooks/CSRHooks/useArticle";
import { count, getBrand } from "@components/config/helpers";
import { useTemplatePageContent } from "../Providers/TemplatePageContentContext";

// const ArticleIcon = dynamic(() => import("./ArticleIcon"));
const ArticleSkeleton = dynamic(() => import("./ArticleSkeleton"));
const ArticleArchives = dynamic(() => import("./ArticleArchives"));
const ArticleContainer = dynamic(() => import("./ArticleContainer"));
const ArticlePagination = dynamic(() => import("./ArticlePagination"));
const BoxContainer = dynamic(() => import("../Reusables/BoxContainerV2"));
const PageHead = dynamic(() => import("../Reusables/PageHead"));
const RecentArticles = dynamic(() => import("./RecentArticles"));

const Articles = (props) => {

    const {
        props: articleProps,
        loading: parentLoader,
    } = props;

    const { loading, localArticleData } = useArticle(articleProps);

    const {
        archive_first_key,
        article_dates,
        articles,
        breadcrumb,
        day,
        meta_desc,
        month,
        per_page,
        title,
        type,
        year,
        template_page_settings
    } = localArticleData;

    const layout = template_page_settings.layout;
    const { isMobile } = useWindowSize();
    const router = useRouter();

    const [page, setPage] = useState(articles.current_page)
    const handleChange = (event, value) => {
        const query = { ...router.query };
        query.page = value;
        router.push({ pathname: router.pathname, query }, undefined, { shallow: true });
        setPage(query.page)
    };

    const setPerPage = (event) => {
        const query = { ...router.query };
        query.per_page = event.target.value;
        router.push({ pathname: router.pathname, query }, undefined, { shallow: true });
    };

    const { template_settings, agent, pageSpinner } = useSelector((state) => state.globalReducer);

    const { template_page_content, meta } = useTemplatePageContent();
    const page_content = template_page_content;

    return (
        <>
            {/* <Head>
                        <title>{`Our ${data.title} - Page ${data.articles.current_page} - ${process.env.brand.brand_name}`}</title>
                        <meta
                            name="description"
                            content={data.meta_description}
                        />
                    </Head> */}

            <PageHead
                title={`${meta.meta_title} - Page ${page} - ${process.env.brand.brand_name}`}
                description={meta.meta_description}
                ogTitle={meta.og_title}
                ogType={meta.og_type}
                ogUrl={meta.og_url}
                ogImage={meta.og_image}
                ogDescription={meta.og_description}
                ogSiteName={meta.og_site_name}
            />

            <BoxContainer className={"mt-2"} mobileClasses={'pl-2 pr-2'} >


                <Grid spacing={{ xs: 0, md: 3 }} container>
                    <Grid item size={{ lg: 9, xs: 12 }}>
                        <Grid container>
                            <Grid item size={{ xs: 12 }}>
                                <ArticlePagination
                                    count={articles.last_page}
                                    page={page}
                                    per_page={articles.per_page}
                                    from={articles.from}
                                    to={articles.to}
                                    total={articles.total}
                                    handlePaginationChange={handleChange}
                                    setPerPage={setPerPage}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12 }}>
                                <Grid spacing={3} container>
                                    {
                                        (loading) || (parentLoader) || (pageSpinner) ? (
                                            <ArticleSkeleton />
                                        ) : articles.data.map((article) => (
                                            <Fragment key={article.article_id}>
                                                <Grid item size={{ xs: 12, md: count(articles.data) == 1 ? 12 : 6 }}>
                                                    <Box className="mb-5" component="article">
                                                        <Grid spacing={1} container>
                                                            {/* <Grid item>
                                                        <ArticleIcon 
                                                            article={article}
                                                            type={type}
                                                        />
                                                    </Grid> */}

                                                            <Grid item size={{ xs: 12, md: 12 }}>
                                                                <ArticleContainer type={type} article={article} />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                            </Fragment>
                                        ))
                                    }

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid className="" item size={{ lg: 3, xs: 12 }}>
                        <Box>
                            {!getBrand('EH') ? (
                                <ArticleArchives
                                    type={type}
                                    article_dates={article_dates}
                                />
                            ) : (
                                <RecentArticles type={type} recentArticles={localArticleData.articles.data} />
                            )}
                        </Box>
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <ArticlePagination
                            count={articles.last_page}
                            page={page}
                            per_page={articles.per_page}
                            from={articles.from}
                            to={articles.to}
                            total={articles.total}
                            handlePaginationChange={handleChange}
                            setPerPage={setPerPage}
                        />
                    </Grid>


                </Grid>


            </BoxContainer>
        </>

    )
}

export default Articles